export const userSettingsI18nSegment = (): string => 'user-settings';
